import { Progress } from "antd";
import { type ProgressProps } from "antd/lib/progress";
import { PureComponent } from "react";

import { cn } from "@btnet/utilities-core";

import "./BTProgressBar.less";

interface IBTProgressBarProps extends ProgressProps {
    "data-testid"?: string;
    boldText?: boolean;
    hideProgressText?: boolean;
    changeLabelToBdsFont?: boolean;
    useDefaultFont?: boolean;
    useDefaultTrailStyle?: boolean;
}
export default class BTProgressBar extends PureComponent<IBTProgressBarProps> {
    private formatProgressBarText = () => {
        return `${Math.round(this.props.percent ?? 0)}%`;
    };

    // Modern progress-bar style is the default: round caps, brand-secondary3 stroke, non-bold text,
    // and the gray-10 trail. strokeWidth is intentionally left to the call site. Call sites can
    // still override any of these per usage.
    static defaultProps = {
        boldText: false,
        hideProgressText: false,
        useDefaultFont: false,
        useDefaultTrailStyle: false,
        strokeLinecap: "round" as const,
        strokeColor: "var(--bui-token-color-brand-secondary3)",
        trailColor: "var(--bui-token-color-gray-10)",
    };

    render() {
        const {
            boldText,
            hideProgressText,
            changeLabelToBdsFont,
            strokeLinecap,
            strokeColor,
            className,
            strokeWidth,
            trailColor,
            useDefaultFont,
            useDefaultTrailStyle,
            ...progressProps
        } = this.props;
        const progressClassName = cn("BTProgressBar", className, {
            BTProgressBarBoldText: boldText,
            hideProgressText: hideProgressText,
            useDefaultFont: useDefaultFont,
            useDefaultTrailStyle: useDefaultTrailStyle,
        });
        return (
            <Progress
                {...progressProps}
                className={progressClassName}
                status="normal"
                strokeLinecap={strokeLinecap}
                strokeColor={strokeColor}
                format={this.formatProgressBarText}
                strokeWidth={strokeWidth}
                trailColor={trailColor}
            />
        );
    }
}
